import { api } from "./client"

export type OrgRole = "owner" | "admin" | "recruiter" | "viewer"

export type OrgProfile = {
  id: string
  name: string
  slug: string
  website: string | null
  logo_url: string | null
  career_page_slug: string
  plan: string
}

export type Member = {
  id: string
  user_id: string
  role: OrgRole
  email: string
  full_name: string | null
  joined_at: string
}

export type PendingInvite = {
  id: string
  email: string
  role: Exclude<OrgRole, "owner">
  expires_at: string
  created_at: string
}

export const orgsApi = {
  current: () => api<{ data: OrgProfile }>("/orgs/current"),
  update: (body: Partial<Pick<OrgProfile, "name" | "website" | "logo_url" | "career_page_slug">>) =>
    api<{ ok: boolean; data: OrgProfile }>("/orgs/current", { method: "PUT", body }),
  members: () => api<{ data: Member[] }>("/orgs/members"),
  setMemberRole: (memberId: string, role: Exclude<OrgRole, "owner">) =>
    api<{ ok: boolean }>(`/orgs/members/${memberId}`, { method: "PUT", body: { role } }),
  removeMember: (memberId: string) =>
    api<{ ok: boolean }>(`/orgs/members/${memberId}`, { method: "DELETE" }),
  invitations: () => api<{ data: PendingInvite[] }>("/orgs/invitations"),
  revokeInvitation: (id: string) =>
    api<{ ok: boolean }>(`/orgs/invitations/${id}`, { method: "DELETE" }),
}
